import React from "react";
import AmazonLogo from '../assets/amzn-logo.png'
import FitbotsLogo from '../assets/logo-ftibots.png'
import VitspotLogo from '../assets/vitspot-logo-big.png'
import HouseOfBabasLogo from '../assets/house-of-babas.png'
import GullakLogo from '../assets/gullaklogo.png'

const Experience = () => {
  return (
    <>
      <section
        className="container mx-auto p-10 md:p-32 md:pt-16"
        id="experience"
      >
        <h2 className="md:text-5xl text-center font-bold text-white text-4xl mb-14 md:mb-16">
          👨‍💻 Experience
        </h2>
        <ol className="relative border-l-2 border-gray-600 px-4">
        <li className="mb-10 ml-6">
          <span className="flex absolute -left-6 sm:-left-10 justify-center items-center w-12 h-12 sm:w-16 sm:h-16 rounded-full ring-2 ring-white bg-white">
              <img src={GullakLogo} alt="logo" className="object-cover w-full h-full rounded-full"/>
            </span>
            <h3 className="flex items-center text-left mb-1 text-2xl font-bold text-white">
              {" "}
              Software Developer Engineer - 1
            </h3>
            <div className="leading-sm mb-3 mt-2 inline-flex items-center rounded-full bg-green-200 px-3 py-1 text-xs font-bold  text-green-700">
              Gullak: India's Savings App
            </div>
            <p>
              {" "}
              <time className="block mb-2 text-sm font-semibold leading-none text-gray-200">
                September 2023 - Present
              </time>
            </p>
            <ol className="mb-4 text-lg font-normal text-gray-300 flex flex-col gap-2">
              <li>
                - Developed the frontend flows for silver investments via Gullak, where the users can invest in digital silver and setup SIPs of daily, weekly, monthly.
              </li>
              <li>
                {" "}
                - Implemented UI limits for widgets/nudges on Homescreen of the application, helps in experimenting with user experience.
              </li>
              <li>
                - Developed redeemable functionality of gold from jewellers such as cartlane and users can pay via gullak in exchange to any ornament.
              </li>
              <li>
                - Integrated content management system with admin dashboard where content team can upload blogs directly and publish to the website. These blogs are highly SEO optimized with the help of SSG via Next.js 
              </li>
            </ol>
          </li>
          <li className="mb-10 ml-6">
          <span className="flex absolute -left-6 sm:-left-10 justify-center items-center w-12 h-12 sm:w-16 sm:h-16 rounded-full ring-2 ring-white object-contain bg-white">
              <img src={AmazonLogo} alt="logo"/>
            </span>
            <h3 className="flex items-center text-left mb-1 text-2xl font-bold text-white">
              {" "}
              Software Developer Engineer Intern{" "}
            </h3>
            <div className="leading-sm mb-3 mt-2 inline-flex items-center rounded-full bg-green-200 px-3 py-1 text-xs font-bold  text-green-700">
              Amazon.com, Inc
            </div>
            <p>
              {" "}
              <time className="block mb-2 text-sm font-semibold leading-none text-gray-200">
                January 2023 - July 2023
              </time>
            </p>
            <ol className="mb-4 text-lg font-normal text-gray-300 flex flex-col gap-2">
              <li>
                - Integrated a tier-1 orchestration engine to the existing
                notifications platform, which will provide the redrive
                capability for the failed notifications and positively impacting
                100k+ customers.
              </li>
              <li>
                {" "}
                - Developed 3 new APIs using internal framework similar to
                spring, which replaced the existing in-memory notification
                orchestration logic to adapt to the new orchestration engine.
              </li>
              <li>
                - Minified the static assets such as CSS/JS on ORC pages which
                helps in reducing the latencies and payload size on page load.
              </li>
            </ol>
          </li>

          <li className="mb-10 ml-6">
          <span className="flex absolute -left-6 sm:-left-10 justify-center items-center w-12 h-12 sm:w-16 sm:h-16 rounded-full ring-4 ring-white bg-white object-contain">
              <img src={FitbotsLogo} alt="logo"/>
            </span>
            <h3 className="flex items-center text-left mb-1 text-2xl font-bold text-white">
              {" "}
              Software Developer Engineer Intern{" "}
            </h3>
            <div className="leading-sm mb-3 mt-2 inline-flex items-center rounded-full bg-green-200 px-3 py-1 text-xs font-bold  text-green-700">
              Hizen Intelligence Systems Pvt Ltd
            </div>
            <p>
              {" "}
              <time className="block mb-2 text-sm font-semibold leading-none text-gray-200">
                June 2021 - July 2021
              </time>
            </p>
            <ol className="mb-4 text-lg font-normal text-gray-300 flex flex-col gap-2">
              <li>
                - Developed a URL checker sub-application using electron JS,
                which can detect whether the back-end API URLs' of the company
                are whitelisted or not.
              </li>
              <li>
                {" "}
                - Integrated the web application to electron application.
              </li>
              <li>
                - Initiated and Analyzed the requirements of react storybook and
                react style guide for the organization
              </li>
              <li>
                - Customized the electron application with navigation menu and
                other features as per the company's requirements.
              </li>
            </ol>
          </li>

          <li className="mb-10 ml-6">
            <span className="flex absolute -left-6 sm:-left-10 justify-center items-center w-12 h-12 sm:w-16 sm:h-16 rounded-full ring-2 ring-white object-contain bg-white p-1">
              <img src={VitspotLogo} alt="logo"/>
            </span>
            <h3 className="flex items-center mb-1 text-2xl font-bold text-white">
              {" "}
              Core technical member{" "}
            </h3>
            <div className="leading-sm mb-3 mt-2 inline-flex items-center rounded-full bg-green-200 px-3 py-1 text-xs font-bold  text-green-700">
              VITSpot Community
            </div>
            <p>
              {" "}
              <time className="block mb-2 text-sm font-semibold leading-none text-gray-200">
                March 2021 - April 2022
              </time>
            </p>
            <ol className="mb-4 text-lg font-normal text-gray-300 flex flex-col gap-2">
              <li>
                - Developed and Integrated class groups feature, this can help
                in finding your whatsapp class groups based on faculty and
                course name. Increased page-views to 17,000 page-views in first
                week
              </li>
              <li>
                - Integrated timetable feature to VITspot website, this feature
                can quickly import your classes from VTOP to google calendar,
                outlook with just one click.
              </li>
              <li>
                - Planned and developed VIT calculators module where students
                can check their GPA and CGPA, worked on major parts of VITspot
                web application.
              </li>
            </ol>
          </li>

          <li className="mb-10 ml-6">
          <span className="flex absolute -left-6 sm:-left-10 justify-center items-center w-12 h-12 sm:w-16 sm:h-16 rounded-full ring-2 ring-white object-contain bg-white p-1">
              <img src={HouseOfBabasLogo} alt="logo" className="object-contain rounded-full"/>
            </span>
            <h3 className="flex items-center mb-1 text-2xl font-bold text-white">
              {" "}
              React developer Intern{" "}
            </h3>
            <div className="leading-sm mb-3 mt-2 inline-flex items-center rounded-full bg-green-200 px-3 py-1 text-xs font-bold  text-green-700">
              House of babas
            </div>
            <p>
              {" "}
              <time className="block mb-2 text-sm font-semibold leading-none text-gray-200">
                Novomber 2020 - March 2021
              </time>
            </p>
            <ol className="mb-4 text-lg font-normal text-gray-300 flex flex-col gap-2">
              <li>
                - Co-ordinated with front-end team and improvised, customized
                website using ReactJS and Sass
              </li>
              <li>
                {" "}
                - Optimized the home page which contains products, by caching
                the product images via CDN and reducing the loadtime of the
                website. Also developed and deployed checkout, sign-up pages for
                the website and coordinated with design team to achieve best
                results
              </li>
            </ol>
          </li>
        </ol>
      </section>
    </>
  );
};

export default Experience;
